import React, { useState, useEffect } from "react";
import Swal from "sweetalert2";
import { useTranslation } from "react-i18next";
import ConnectAPI from "../../../services/api";
import { numberFormatCommaTwoFraction } from "./../../../common/js/utils/numberFormat";

const connectApi = new ConnectAPI();
function SpecialConditionDetailTypes_22  ({ specialCondition }) {
    const { t } = useTranslation();
    const [tableData, setTableData] = useState([]);
    const [tableConfig,setTableConfig]=useState([]);
    const [dataLSDiscount,setDataLSDiscount]=useState([]);
    var fetchData;
    var config;
    const getConfigdata=(status,data)=>{
        setTableConfig(data[0]);
    };
    const dataResponseLoad=(status,data)=>{
        setDataLSDiscount(data === undefined ? [] : data);
    };
    
    useEffect(() => {
        config=()=>{
            connectApi.getWithParams("api/Channels/specialConditionConfig",specialCondition.idSpecialCondition , getConfigdata)
            .catch((error) => {
                Swal.fire(
                    "Error " + error?.response?.status,
                    error?.response?.data,
                    "error"
                );
            })
        }
        fetchData = () => {
            connectApi.getWithParams(
                "api/Channels/specialConditionMaximumCostPerPrintLSDiscount", specialCondition.idSpecialCondition, dataResponseLoad
            ).catch((error) => {
                Swal.fire(
                    "Error " + error.response,
                    error.response,
                    "error"
                );
            });
            connectApi.getWithParams("api/Channels/specialConditionMaximumCostPerImpression", specialCondition.idSpecialCondition, getSCdataCallback)
                .catch((error) => {
                    Swal.fire(
                        "Error " + error?.response?.status,
                        error?.response?.data,
                        "error"
                    );
                });
        }
        config();
        fetchData();
        
    }, [specialCondition.idSpecialCondition]);

    let getSCdataCallback;
    getSCdataCallback = (status, data) => {
        setTableData(data);
    }
    let optPercentage = {
        style: 'percent',
        maximumFractionDigits: 2
    };
    let optDecimal = {
        style: 'decimal',
        maximumFractionDigits: 5
    };
    function specialCondition23(){
        if( specialCondition.idSpecialConditionType == 23 ){
            return <>
                <div>Percentage discount: {numberFormatCommaTwoFraction(specialCondition.percentage * 100)} %</div>
                <div>Coverage Below: {specialCondition.minimumImp} %</div>
            </>;
        }
    }
    return (<>
        {specialCondition23()}
        {specialCondition.isGlobal==true?(
            <>
            </>
        ):(
            <>
                <br/>
                <table className="table table-striped table-hover table-bordered table-sm " >
                    <thead>
                        <tr>
                            <th scope="col" className="text-center">
                                Min Print
                            </th>
                            <th scope="col" className="text-center">
                                Max Print
                            </th>
                            {(tableConfig)?(
                                (tableConfig.blackVisible==true)?(
                                    <th scope='col' className='text-center'>Black CPP</th>
                                    ):("")
                            ):(
                                ""
                            )}
                            {(tableConfig)?(
                                (tableConfig.otherVisible==true)?(
                                    <th scope='col' className='text-center'>Other CPP</th>
                                    ):("")
                            ):(
                                ""
                            )}
                            {(tableConfig)?(
                                (tableConfig.oneShotVisible==true)?(
                                    <th scope='col' className='text-center'>One Shot CPP</th>
                                    ):("")
                            ):(
                                ""
                            )}
                            {(tableConfig)?(
                                (tableConfig.whiteVisible==true)?(
                                    <th scope='col' className='text-center'>White CPP</th>
                                    ):("")
                            ):(
                                ""
                            )}
                        </tr>
                    </thead>
                    <tbody>
                        {tableData.map((row, index)=>{
                            return (
                                <tr>
                                    <td scope='col'>{row.minPrint.toLocaleString()}</td>
                                    <td scope='col'>{row.maxPrint.toLocaleString()}</td>
                                    {(tableConfig.blackVisible==true)?(
                                        <td scope='col'>{new Intl.NumberFormat('en-US', optDecimal).format(row.blackCpp)}</td>
                                    ):("")}
                                    {(tableConfig.otherVisible==true)?(
                                        <td scope='col'>{new Intl.NumberFormat('en-US', optDecimal).format(row.otherCpp)}</td>
                                    ):("")}
                                    {(tableConfig.oneShotVisible==true)?(
                                        <td scope='col'>{new Intl.NumberFormat('en-US', optDecimal).format(row.oneShotCpp)}</td>
                                    ):("")}
                                    {(tableConfig.whiteVisible==true)?(
                                        <td scope='col'>{new Intl.NumberFormat('en-US', optDecimal).format(row.whiteCpp)}</td>
                                    ):("")}
                                </tr>
                            )
                        })}
                    </tbody>
                </table>
                *<label style={{fontSize: '12px'}} >{t("note_table")}</label>
            </>
        )}
        { dataLSDiscount.length > 0?(<>
        <br/><br/>
        <table className="table table-striped table-hover table-bordered table-sm " >
            <thead>
                <tr>
                    <th scope="col" className="text-center">
                        InitialLSMark
                    </th>
                    <th scope="col" className="text-center">
                        FinalLSMark
                    </th>
                    <th scope="col" className="text-center">
                        Debit / Credit
                    </th>
                </tr>
            </thead>
            <tbody>
                {dataLSDiscount.map((row, index)=>{
                    return (
                        <tr>
                            <td scope='col'>{row.initialLSMark.toLocaleString()}</td>
                            <td scope='col'>{row.finalLSMark.toLocaleString()}</td>
                            <td scope='col'>{new Intl.NumberFormat('en-US', optPercentage).format(row.discount)}</td>
                        </tr>
                    )
                })}
            </tbody>
        </table>
        </>):(<><br/><br/></>) }
    </>);
}

export default SpecialConditionDetailTypes_22;